import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import RedirectView from "@/views/RedirectView";
import RegisterView from "@/views/RegisterView";
import LogoutView from "@/views/LogoutView";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  { path: '/redirect', component: RedirectView },
  { path: '/logout', component: LogoutView },
  { path: '/register', component: RegisterView }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
